export const wxLite = 'https://help.quupawotooro.com/img/common/wx-lite.png'

export const wxNode = 'https://help.quupawotooro.com/img/common/wx-node.png'

export const wwwActivity = 'https://help.quupawotooro.com/img/common/www-activity.jpg'

export const vipNode = 'https://help.quupawotooro.com/img/common/vip-node.png'

export const vipLite = 'https://help.quupawotooro.com/img/common/vip-lite.jpg'
